module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2022-12-19 at 20.13.31.535bf176.jpeg";